import { render, staticRenderFns } from "./compare-systems.vue?vue&type=template&id=be7b6322"
import script from "./compare-systems.vue?vue&type=script&lang=js"
export * from "./compare-systems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports